import React, { useCallback, memo } from 'react';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import {
  ClientCustomCalendarModel,
  ReportCurrency,
  ReportType,
} from '../../../../models';
import * as Styled from '../styled';
import DateRange from '../date-range/DateRange';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';
import ReportSettingPIT from '../ReportSettingPIT';

interface ReportSettingFiscallRollforwardProps {
  onChange: (updatedValue: ReportSettingFiscalRollforwardState) => void;
  reportSettingState: ReportSettingFiscalRollforwardState;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
  customCalendarSettings?: ClientCustomCalendarModel;
}

export interface ReportSettingFiscalRollforwardState {
  selectedCurrency: SelectOption<ReportCurrency>;
  startDate: string;
  rollforwardThrough: string;
  selectedFiscalStartMonth: SelectOption<string>;
  isValid: boolean;
}

function ReportDateSettingRollforward({
  onChange,
  reportSettingState,
  reportTypeSetting,
  isAllowPIT,
  customCalendarSettings,
}: ReportSettingFiscallRollforwardProps): JSX.Element {
  return (
    <>
      <DateRange
        onChange={useCallback(
          (startDate: string, endDate: string, isValid: boolean): void => {
            onChange({
              ...reportSettingState,
              startDate: startDate,
              rollforwardThrough: endDate,
              isValid: isValid,
            });
          },
          [onChange, reportSettingState],
        )}
        startDate={reportSettingState.startDate}
        endDate={reportSettingState.rollforwardThrough}
      />
      <Styled.Line />
      <ReportSettingPIT
        reportType={ReportType.fiscalRollforward}
        isAllowPIT={isAllowPIT}
        reportSettingState={reportSettingState}
        reportTypeSetting={reportTypeSetting}
        customCalendarSettings={customCalendarSettings}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingFiscalRollforwardState),
          [onChange],
        )}
      />
    </>
  );
}

export default memo(ReportDateSettingRollforward);
